import ResourceProvider from '../ResourceProvider';

const UserReviewResource = (userId) => ResourceProvider(`/resource/users/${userId}/reviews`);

export default UserReviewResource;
